import { render, staticRenderFns } from "./modal-detail.vue?vue&type=template&id=8016ce12&"
import script from "./modal-detail.vue?vue&type=script&lang=js&"
export * from "./modal-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports